// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../client/web/myagent/app/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../client/web/myagent/app/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../client/web/myagent/app/node_modules/css-loader/dist/cjs.js!../styles/variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * ChatInput - Ethereal Tech Design
 *
 * Features floating glass input container with glow effects,
 * elegant send button, and refined focus states.
 */

.chat-input-form {
  position: relative;
  flex-shrink: 0;
  padding: var(--spacing-lg) var(--spacing-md) var(--spacing-xl);
  background: transparent;
  z-index: 1;
}

/* Gradient fade at the top to blend with messages */
.chat-input-form::before {
  content: "";
  position: absolute;
  top: -60px;
  left: 0;
  right: 0;
  height: 60px;
  background: linear-gradient(to top, var(--bg-base) 0%, transparent 100%);
  pointer-events: none;
}

.chat-input-container {
  position: relative;
  display: flex;
  align-items: flex-end;
  gap: var(--spacing-md);
  max-width: 900px;
  margin: 0 auto;
  background: var(--glass-bg);
  backdrop-filter: blur(var(--blur-md));
  -webkit-backdrop-filter: blur(var(--blur-md));
  border-radius: var(--radius-2xl);
  padding: var(--spacing-sm) var(--spacing-md);
  border: 1px solid var(--glass-border);
  box-shadow: var(--shadow-lg);
  transition: all var(--transition-base);
}

/* Inner highlight */
.chat-input-container::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, transparent 50%);
  pointer-events: none;
}

/* Focus glow effect */
.chat-input-container::after {
  content: "";
  position: absolute;
  inset: -2px;
  border-radius: calc(var(--radius-2xl) + 2px);
  background: linear-gradient(135deg, var(--color-primary-glow) 0%, var(--color-accent-glow) 100%);
  opacity: 0;
  z-index: -1;
  transition: opacity var(--transition-base);
}

.chat-input-container:focus-within {
  border-color: var(--input-focus-border);
}

.chat-input-container:focus-within::after {
  opacity: 0.5;
  animation: pulse-glow 2s ease-in-out infinite;
}

@keyframes pulse-glow {
  0%,
  100% {
    opacity: 0.3;
  }
  50% {
    opacity: 0.6;
  }
}

/* ===== Input Field ===== */
.chat-input {
  flex: 1;
  padding: var(--spacing-md);
  background: transparent;
  border: none;
  color: var(--text-primary);
  font-size: var(--font-size-base);
  font-family: var(--font-family);
  outline: none;
  resize: none;
  max-height: 200px;
  min-height: 24px;
  line-height: var(--line-height-normal);
}

.chat-input::placeholder {
  color: var(--text-placeholder);
  transition: color var(--transition-fast);
}

.chat-input:focus::placeholder {
  color: var(--text-dim);
}

.chat-input:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ===== Send Button ===== */
.chat-send-button {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  background: linear-gradient(135deg, var(--color-primary), var(--color-secondary));
  border: none;
  border-radius: var(--radius-lg);
  color: white;
  cursor: pointer;
  transition: all var(--transition-base);
  flex-shrink: 0;
  overflow: hidden;
}

/* Button shine effect */
.chat-send-button::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.25) 0%, transparent 50%);
  opacity: 0;
  transition: opacity var(--transition-fast);
}

.chat-send-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px var(--color-primary-glow);
}

.chat-send-button:hover:not(:disabled)::before {
  opacity: 1;
}

.chat-send-button:active:not(:disabled) {
  transform: translateY(0) scale(0.95);
}

.chat-send-button:disabled {
  background: var(--bg-tertiary);
  opacity: 0.4;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.chat-send-button svg {
  width: 18px;
  height: 18px;
  position: relative;
  z-index: 1;
}

/* ===== @mention Popup ===== */
.mention-popup {
  position: absolute;
  bottom: calc(100% + 4px);
  left: var(--spacing-md);
  min-width: 200px;
  max-width: 300px;
  padding: var(--spacing-xs);
  background: var(--bg-elevated);
  backdrop-filter: blur(var(--blur-lg));
  -webkit-backdrop-filter: blur(var(--blur-lg));
  border: 1px solid var(--glass-border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  z-index: var(--z-dropdown);
}

.mention-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: var(--spacing-sm) var(--spacing-md);
  background: none;
  border: none;
  color: var(--text-secondary);
  font-size: var(--font-size-sm);
  text-align: left;
  cursor: pointer;
  border-radius: var(--radius-md);
  transition: background var(--transition-fast);
}

.mention-item:hover,
.mention-item-active {
  background: rgba(255, 255, 255, 0.05);
  color: var(--text-primary);
}

.mention-item-name {
  font-weight: var(--font-weight-medium);
}

.mention-item-type {
  font-size: var(--font-size-xs);
  color: var(--text-tertiary);
  text-transform: uppercase;
  letter-spacing: var(--letter-spacing-wider);
}

/* ===== Responsive ===== */
@media (max-width: 768px) {
  .chat-input-form {
    padding: var(--spacing-md) var(--spacing-sm) var(--spacing-lg);
  }

  .chat-input-container {
    border-radius: var(--radius-xl);
    padding: var(--spacing-xs) var(--spacing-sm);
  }

  .chat-input {
    padding: var(--spacing-sm);
    font-size: var(--font-size-sm);
  }

  .chat-send-button {
    width: 36px;
    height: 36px;
    border-radius: var(--radius-md);
  }

  .chat-send-button svg {
    width: 16px;
    height: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./../../../../packages/apps/myagent/myagent_ui/src/components/ChatInput.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAIF;EACE,kBAAkB;EAClB,cAAc;EACd,8DAA8D;EAC9D,uBAAuB;EACvB,UAAU;AACZ;;AAEA,oDAAoD;AACpD;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,wEAAwE;EACxE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,2BAA2B;EAC3B,qCAAqC;EACrC,6CAA6C;EAC7C,gCAAgC;EAChC,4CAA4C;EAC5C,qCAAqC;EACrC,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,kFAAkF;EAClF,oBAAoB;AACtB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,4CAA4C;EAC5C,gGAAgG;EAChG,UAAU;EACV,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE;;IAEE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;;AAEA,4BAA4B;AAC5B;EACE,OAAO;EACP,0BAA0B;EAC1B,uBAAuB;EACvB,YAAY;EACZ,0BAA0B;EAC1B,gCAAgC;EAChC,+BAA+B;EAC/B,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,iFAAiF;EACjF,YAAY;EACZ,+BAA+B;EAC/B,YAAY;EACZ,eAAe;EACf,sCAAsC;EACtC,cAAc;EACd,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,kFAAkF;EAClF,UAAU;EACV,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,8BAA8B;EAC9B,qCAAqC;EACrC,6CAA6C;EAC7C,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,4CAA4C;EAC5C,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;;EAEE,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA,2BAA2B;AAC3B;EACE;IACE,8DAA8D;EAChE;;EAEA;IACE,+BAA+B;IAC/B,4CAA4C;EAC9C;;EAEA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,+BAA+B;EACjC;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/**\n * ChatInput - Ethereal Tech Design\n *\n * Features floating glass input container with glow effects,\n * elegant send button, and refined focus states.\n */\n\n@import \"../styles/variables.css\";\n\n.chat-input-form {\n  position: relative;\n  flex-shrink: 0;\n  padding: var(--spacing-lg) var(--spacing-md) var(--spacing-xl);\n  background: transparent;\n  z-index: 1;\n}\n\n/* Gradient fade at the top to blend with messages */\n.chat-input-form::before {\n  content: \"\";\n  position: absolute;\n  top: -60px;\n  left: 0;\n  right: 0;\n  height: 60px;\n  background: linear-gradient(to top, var(--bg-base) 0%, transparent 100%);\n  pointer-events: none;\n}\n\n.chat-input-container {\n  position: relative;\n  display: flex;\n  align-items: flex-end;\n  gap: var(--spacing-md);\n  max-width: 900px;\n  margin: 0 auto;\n  background: var(--glass-bg);\n  backdrop-filter: blur(var(--blur-md));\n  -webkit-backdrop-filter: blur(var(--blur-md));\n  border-radius: var(--radius-2xl);\n  padding: var(--spacing-sm) var(--spacing-md);\n  border: 1px solid var(--glass-border);\n  box-shadow: var(--shadow-lg);\n  transition: all var(--transition-base);\n}\n\n/* Inner highlight */\n.chat-input-container::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  border-radius: inherit;\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, transparent 50%);\n  pointer-events: none;\n}\n\n/* Focus glow effect */\n.chat-input-container::after {\n  content: \"\";\n  position: absolute;\n  inset: -2px;\n  border-radius: calc(var(--radius-2xl) + 2px);\n  background: linear-gradient(135deg, var(--color-primary-glow) 0%, var(--color-accent-glow) 100%);\n  opacity: 0;\n  z-index: -1;\n  transition: opacity var(--transition-base);\n}\n\n.chat-input-container:focus-within {\n  border-color: var(--input-focus-border);\n}\n\n.chat-input-container:focus-within::after {\n  opacity: 0.5;\n  animation: pulse-glow 2s ease-in-out infinite;\n}\n\n@keyframes pulse-glow {\n  0%,\n  100% {\n    opacity: 0.3;\n  }\n  50% {\n    opacity: 0.6;\n  }\n}\n\n/* ===== Input Field ===== */\n.chat-input {\n  flex: 1;\n  padding: var(--spacing-md);\n  background: transparent;\n  border: none;\n  color: var(--text-primary);\n  font-size: var(--font-size-base);\n  font-family: var(--font-family);\n  outline: none;\n  resize: none;\n  max-height: 200px;\n  min-height: 24px;\n  line-height: var(--line-height-normal);\n}\n\n.chat-input::placeholder {\n  color: var(--text-placeholder);\n  transition: color var(--transition-fast);\n}\n\n.chat-input:focus::placeholder {\n  color: var(--text-dim);\n}\n\n.chat-input:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ===== Send Button ===== */\n.chat-send-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  background: linear-gradient(135deg, var(--color-primary), var(--color-secondary));\n  border: none;\n  border-radius: var(--radius-lg);\n  color: white;\n  cursor: pointer;\n  transition: all var(--transition-base);\n  flex-shrink: 0;\n  overflow: hidden;\n}\n\n/* Button shine effect */\n.chat-send-button::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.25) 0%, transparent 50%);\n  opacity: 0;\n  transition: opacity var(--transition-fast);\n}\n\n.chat-send-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 24px var(--color-primary-glow);\n}\n\n.chat-send-button:hover:not(:disabled)::before {\n  opacity: 1;\n}\n\n.chat-send-button:active:not(:disabled) {\n  transform: translateY(0) scale(0.95);\n}\n\n.chat-send-button:disabled {\n  background: var(--bg-tertiary);\n  opacity: 0.4;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.chat-send-button svg {\n  width: 18px;\n  height: 18px;\n  position: relative;\n  z-index: 1;\n}\n\n/* ===== @mention Popup ===== */\n.mention-popup {\n  position: absolute;\n  bottom: calc(100% + 4px);\n  left: var(--spacing-md);\n  min-width: 200px;\n  max-width: 300px;\n  padding: var(--spacing-xs);\n  background: var(--bg-elevated);\n  backdrop-filter: blur(var(--blur-lg));\n  -webkit-backdrop-filter: blur(var(--blur-lg));\n  border: 1px solid var(--glass-border);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-lg);\n  z-index: var(--z-dropdown);\n}\n\n.mention-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: var(--spacing-sm) var(--spacing-md);\n  background: none;\n  border: none;\n  color: var(--text-secondary);\n  font-size: var(--font-size-sm);\n  text-align: left;\n  cursor: pointer;\n  border-radius: var(--radius-md);\n  transition: background var(--transition-fast);\n}\n\n.mention-item:hover,\n.mention-item-active {\n  background: rgba(255, 255, 255, 0.05);\n  color: var(--text-primary);\n}\n\n.mention-item-name {\n  font-weight: var(--font-weight-medium);\n}\n\n.mention-item-type {\n  font-size: var(--font-size-xs);\n  color: var(--text-tertiary);\n  text-transform: uppercase;\n  letter-spacing: var(--letter-spacing-wider);\n}\n\n/* ===== Responsive ===== */\n@media (max-width: 768px) {\n  .chat-input-form {\n    padding: var(--spacing-md) var(--spacing-sm) var(--spacing-lg);\n  }\n\n  .chat-input-container {\n    border-radius: var(--radius-xl);\n    padding: var(--spacing-xs) var(--spacing-sm);\n  }\n\n  .chat-input {\n    padding: var(--spacing-sm);\n    font-size: var(--font-size-sm);\n  }\n\n  .chat-send-button {\n    width: 36px;\n    height: 36px;\n    border-radius: var(--radius-md);\n  }\n\n  .chat-send-button svg {\n    width: 16px;\n    height: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
